<template>
  <section id="section-included">
    <SectionHeading id="toc-included" icon="icon-common-file-text-check" title="Included" />

    <ul class="items">
      <li v-for="line in itinerary.productIncludedInPriceHtml">
        <i class="icon icon-check-circle-1"></i>
        <div v-html="line"></div>
      </li>
    </ul>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'

const store = useItineraryStore()
const {
  data: { itinerary },
} = store
store.monitorVisibility('included', '#section-included')
</script>

<style lang="scss" scoped>
section {
  @include flex-column(20px);
}

.items {
  @include flex-column(20px);

  li {
    display: flex;
    gap: 12px;
    font-weight: 400;
  }

  .icon {
    color: $brand-tertiary;
  }
}
</style>
